import { OrderProductsWithErrors } from '../../../../../services/modules/order-product/order-product.types';
import { OrderProduct, Section, SectionPendencyEnum } from '../../orderProducts.types';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupByPendency extends OrderProductsBuilder {
  private sectionWithErrors: Section = {
    products: [],
    productsCount: 0,
    isExpanded: true,
    pendency: SectionPendencyEnum.WITH_PENDENCIES,
  };

  private sectionWithoutErrors: Section = {
    products: [],
    productsCount: 0,
    isExpanded: true,
    pendency: SectionPendencyEnum.WITHOUT_PENDENCIES,
  };

  group({ orderProducts, orderProductsWithErrors }: OrderProductsGroupProps): Section[] {
    this.groupProductsByPendency(orderProducts, orderProductsWithErrors);
    return this.getSections();
  }

  private groupProductsByPendency(
    orderProducts: OrderProduct[],
    orderProductsWithErrors?: OrderProductsWithErrors,
  ) {
    orderProducts.forEach((op) => {
      this.validateOrderProductPendency(op, orderProductsWithErrors);
    });
  }

  private validateOrderProductPendency(op: OrderProduct, opwe?: OrderProductsWithErrors) {
    const orderProductKeyIds = `${op.productColorId}/${op.availability}/${
      op.deliveryWindow?.id || null
    }`;
    const productErrors = opwe ? opwe[orderProductKeyIds] : [];
    if (productErrors?.length > 0) {
      this.addToSectionWithErrors(op);
    } else {
      this.addToSectionWithoutErrors(op);
    }
  }

  private addToSectionWithErrors(op: OrderProduct) {
    this.sectionWithErrors.products.push(op);
    this.sectionWithErrors.productsCount += 1;
  }

  private addToSectionWithoutErrors(op: OrderProduct) {
    this.sectionWithoutErrors.products.push(op);
    this.sectionWithoutErrors.productsCount += 1;
  }

  private getSections() {
    if (this.sectionWithErrors.productsCount === 0) {
      return [this.sectionWithoutErrors];
    }
    if (this.sectionWithoutErrors.productsCount === 0) {
      return [this.sectionWithErrors];
    }
    return [this.sectionWithErrors, this.sectionWithoutErrors];
  }
}

export default OrderProductsGroupByPendency;
